import React, { lazy, Suspense, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Bugraphs } from "../components/Builders/Bugrafx/Bugraphs";
import { getDataUser, setTemporalUsers } from "../libs/redux/slices/authSlice/authSlice";
import { useGetGraphsQuery } from "../libs/redux/slices/Graficsx/graficsxApiSlice";
import { useGetUserTemporalQuery, useGetDashboardQuery, useGetTurnsTodayByUserQuery } from "../libs/redux/slices/authSlice/authApiSlice";
import { TableLoader, BoxStatus, ShiftBanner, Box, TrafficLightModal } from "codekit";
import { setInitialFilter } from "../libs/redux/slices/Graficsx/Criticid/criticidSlice";
import { useGetQuantityCriticalQuery } from "../libs/redux/slices/Graficsx/Criticid/criticidApiSlice";
import { Buttonsx, Galerdas } from "../components/Dashboax";
import { useGetVisiblesQuery } from "../libs/redux/slices/Paramgen/Dashestx/dashestxApiSlice";

function DashboardHome() {
  const dispatch = useDispatch();
  const [currentView, setCurrentView] = useState("HOME");
  const { USRIDXXX, CARIDXXX, USRNOMXX } = useSelector(getDataUser);
  const { data: graphs } = useGetGraphsQuery({ USRIDXXX, CARIDXXX });
  //Los tableros estaticos del cargo (CIMS0118). RTK Query cachea la respuesta, asi que Galerdas
  //reusa esta misma consulta y no se pide dos veces.
  const { data: visibles, isLoading: isLoadingVisibles } = useGetVisiblesQuery();
  const { data: turnsByUser } = useGetTurnsTodayByUserQuery({ USRIDXXX });
  const { data: temporalUsers, isSuccess } = useGetUserTemporalQuery({ USRIDXXX });
  const [banner, setBanner] = React.useState(null);
  const { data: dataGraphics, isSuccess: isSuccessGraphics } = useGetDashboardQuery();
  const graphicsTurn = ["NOTITURN"];
  const [isOpen, setIsOpen] = useState(true)
  const criticidRef = useRef(null);
  const [isCritical, setIsCritical] = useState(false)
  const { data: criticalOperations, isSuccess: isSuiccessCritical } = useGetQuantityCriticalQuery(
    {},
    { refetchOnMountOrArgChange: true },
  );
  const [quantityCritical, setQuantityCritical] = useState(0)

  const toDateAt = (dateStr, timeStr) => new Date(`${dateStr}T${timeStr}`);

  const fmtHour = (d) =>
    d.toLocaleTimeString('es-CO', { hour: 'numeric', minute: '2-digit', hour12: true });


  //Hook para el seteo de los usuarios reemplazo
  useEffect(() => {
    if (isSuccess) {
      const { data = [] } = temporalUsers;
      dispatch(setTemporalUsers(data));
    }
  }, [isSuccess, temporalUsers, dispatch]);

  //Hook para validar si se encontraron operaciones criticas
  useEffect(() => {
    if (isSuiccessCritical) {
      const { data = {} } = criticalOperations;
      if (Object.keys(data).length > 0) {
        setIsCritical(true)
        setQuantityCritical(data["ROJO"].total)
      }
    }
  }, [isSuiccessCritical, criticalOperations])

  React.useEffect(() => {
    const compute = () => {
      const dayData = turnsByUser?.data;
      const turns = dayData?.TURNSXXX ?? [];

      if (!Array.isArray(turns) || turns.length === 0) {
        setBanner({ visible: false, variant: 'start', primary: '', secondary: '' });
        return;
      }

      const dateStr = dayData.DATEXXXX;

      const ranges = turns
        .flatMap(t => (t.RANGESXX ?? []).map(r => ({
          start: toDateAt(dateStr, r.STARTXXX),
          end: toDateAt(dateStr, r.ENDXXXXX),
        })))
        .sort((a, b) => a.start - b.start);

      const now = new Date();

      const current = ranges.find(r => now >= r.start && now < r.end);
      if (current) {
        setBanner({
          visible: true,
          variant: 'end',
          primary: `Tu turno termina a las ${fmtHour(current.end)}`,
          secondary: 'Recuerda finalizar tu turno en la opción Cerrar Turno',
        });
        return;
      }

      const next = ranges.find(r => now < r.start);
      if (next) {
        setBanner({
          visible: true,
          variant: 'start',
          primary: `Tu turno inicia a las ${fmtHour(next.start)}`,
          secondary: `Hoy (${dayData.DAYXXXXX}). Recuerda finalizar tu turno en la opción Cerrar Turno`,
        });
        return;
      }

      setBanner({ visible: false, variant: 'start', primary: '', secondary: '' });
    };

    compute();
    const id = setInterval(compute, 5 * 60 * 1000); // 5 minutos
    return () => clearInterval(id);
  }, [turnsByUser]);

  //Se espera tambien a los tableros para que la barra de pestañas no aparezca a medias
  if (!isSuccessGraphics || !graphs || isLoadingVisibles) {
    return <BoxStatus variant="loading" text="Cargando información..." />;
  }
  //Sin lista blanca (FASE 5, root/cimaapi#355): lo que Bugraphs pinta es
  //lo que trae SU consulta; el resto de la plantilla del cargo se monta
  //por lazy import desde la ruta del catalogo. Registrar un widget nuevo
  //es un INSERT — el front ya no opina.
  const bugraphSet = new Set(
    Array.isArray(graphs?.data) ? graphs.data.map((g) => g.GRACOMXX) : []
  );
  const hasBugraphs =
    Array.isArray(graphs?.data) &&
    graphs.data.some((g) =>
      dataGraphics.data.some((d) => d.GRACOMXX === g.GRACOMXX)
    );
  const hasTurns = dataGraphics.data.some(
    (item) => graphicsTurn.includes(item.GRACOMXX)
  );
  const otherComponents = dataGraphics.data.filter(
    (item) => !bugraphSet.has(item.GRACOMXX) && !graphicsTurn.includes(item.GRACOMXX)
  );

  //Que pestañas se ven depende de lo que el cargo tenga asignado, no de una lista de cargos en el
  //codigo: HOME sale de la parametrica de graficas (CIMS0037) y TABLEROS de la de tableros
  //estaticos (CIMS0118). Con una sola de las dos la barra no aporta nada y se entra directo.
  const hasGraficas = dataGraphics.data.length > 0;
  const hasTableros = (visibles?.data?.length ?? 0) > 0;
  const showTabs = hasGraficas && hasTableros;
  const currentTab = showTabs ? currentView : hasTableros ? "TABLEROS" : "HOME";

  //Funcion redirigir la dashboard de operaciones criticas
  const handleClickPopup = (color) => {
    setIsOpen(false)
    dispatch(setInitialFilter(color))
    setTimeout(() => {
      criticidRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }, 300)
  }

  return (
    <>
      {/**Criticidad operacion */}
      {isCritical && (
        <TrafficLightModal
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          title={`Bienvenid@ ${USRNOMXX}`}
          subtitle="Tienes"
          bottomText="OPERACIONES CRÍTICAS"
          bgColor="error-500"
          onClick={() => handleClickPopup("ROJO")}
        >
          {quantityCritical}
        </TrafficLightModal>
      )}
      {showTabs && <Buttonsx currentView={currentTab} handleCurrentView={setCurrentView} />}
      {hasGraficas && (
        <Box style={{ display: currentTab === "HOME" ? "block" : "none" }}>
          {hasTurns && banner?.visible && (
            <Box spacing={5}>
              <ShiftBanner
                variant={banner.variant}
                srcBgImage="/images/cima-icon.png"
                primaryText={banner.primary}
                secondaryText={banner.secondary}
                alignment="left"
                imageRotation={-10}
                imageX={95}
              />
            </Box>
          )}
          {hasBugraphs && <Bugraphs graphs={graphs.data} />}
          {otherComponents.map((CIMS0036, index) => {
            //La ruta del catalogo manda; GRACOMXX queda como convencion
            //historica para filas sin ruta parametrizada.
            const rutaWidget = CIMS0036.GRARUTAX || CIMS0036.GRACOMXX;
            const CurrentGraphic = lazy(() =>
              import(`../components/${rutaWidget}`).catch((error) => {
                console.error("DashboardHome: widget no cargó:", rutaWidget, error);
                return { default: () => null };
              })
            );
            const isCriticid = CIMS0036.GRACOMXX === 'CRITICID'

            return (
              <Suspense fallback={<TableLoader />} key={index}>
                <div ref={isCriticid ? criticidRef : null}>
                  <CurrentGraphic />
                </div>
              </Suspense>
            );
          })}
        </Box>
      )}
      {hasTableros && currentTab === "TABLEROS" && <Galerdas />}
    </>
  );
}

export default DashboardHome;
